export default "__VITE_ASSET__CSKHA1Tx__"